import React, { Component } from "react";
import PropTypes from "prop-types";
import AccordionContainer from "./AccordionContainer";
import AccordionContent from "./AccordionContent";
import Button from "../Button";
import Link from "../Link";
import Icon from "../Icons";
import styled from "styled-components";

const Title = styled.div`
  display: flex;
  width: 100%;

  span {
    font-size: 21px;
    line-height: 25px;
  }

  em {
    background-color: #ffad20;
    font-style: normal;
  }

  svg {
    height: 100%;
    margin-right: 10px;
  }

  &:not(.text_edit:hover) {
    color: #16283f;

    svg {
      display: none;
    }
  }

  &.text_edit:hover {
    color: #eb5757;
    cursor: pointer;

    svg {
      display: inline-block;
    }
  }

  @media (max-width: 768px) {
    span {
      font-size: 16px;
      font-weight: bold;
    }
  }
`;

const Description = styled.div`
  display: flex;
  padding-bottom: 15px;

  span {
    font-family: Merriweather, sans-serif;
    font-weight: 300;
    font-size: 15px;
    line-height: 25px;
  }

  em {
    background-color: #ffad20;
    font-style: normal;
  }

  svg {
    height: 100%;
    margin-right: 10px;
  }

  &:not(.text_edit:hover) {
    color: #000000;

    svg {
      display: none;
    }
  }

  &.text_edit:hover {
    color: #eb5757;
    cursor: pointer;

    svg {
      display: inline-block;
    }
  }

  @media (max-width: 768px) {
    padding-bottom: 10px;

    span {
      font-size: 14px;
    }
  }
`;

const ViewButton = styled(Button)`
  border: none;
  background: inherit;
  padding: 0 !important;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 10px;

  > :not(:last-child) {
    margin-right: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;

  & button {
    font-family: Rubik, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    padding: 5px 10px;

    @media (max-width: 768px) {
      font-size: 12px;
      padding: 3px 10px;
    }
  }

  > :not(:last-child) {
    margin-right: 10px;
  }
`;

const TitleIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ gridLength }) => gridLength}, auto);
  gap: 15px;
  align-items: center;
`;

export default class Accordion extends Component {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    open: PropTypes.bool,
    description: PropTypes.string,
    onHandleClick: PropTypes.func,
    onEditClick: PropTypes.func,
    isContentDisabled: PropTypes.bool,
    onTitleClick: PropTypes.func,
    onDescriptionClick: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      edit: false,
    };
  }

  componentWillReceiveProps(props) {
    if (!props.open && props.isContentDisabled) this.setState({ edit: false });
  }

  handleClick = () => {
    if ((this.props.open && this.state.edit) || !this.props.isContentDisabled)
      this.props.onTitleClick();
  };

  descriptionClick = () => {
    if ((this.props.open && this.state.edit) || !this.props.isContentDisabled) {
      this.props.onDescriptionClick();
    }
  };

  editClick = () => {
    this.props.onEditClick();
    this.setState({ edit: !this.state.edit });
  };

  buttonClick = () => {
    this.setState({ edit: false });
    this.props.onHandleClick();
  };

  onEditClickConstructor = () => {
    const { onEditClick, isContentDisabled, open } = this.props;

    !isContentDisabled && onEditClick();
    open && this.editClick();
  };

  render() {
    const {
      title,
      children,
      open,
      isContentDisabled,
      description,
      person,
      editName,
    } = this.props;
    const isEdit = this.state.edit || editName;
    const editedClass = isEdit && "text_edit";
    const gridLength =
      (open && person) || (!isContentDisabled && person) ? 2 : 1;

    return (
      <AccordionContainer
        open={open}
        edit={this.state.edit}
        editName={editName}
      >
        <TitleContainer open={open}>
          <Title onClick={this.handleClick} className={editedClass}>
            <div>
              <Icon icon="pencil" fill="#EB5757" height={12} width={12} />
            </div>
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </Title>
          <TitleIcons gridLength={gridLength}>
            {(open || !isContentDisabled) && (
              <Icon
                onClick={this.onEditClickConstructor}
                height={20}
                width={20}
                fill={isEdit ? "#a36257" : "#999999"}
                icon="edit"
              />
            )}
            {person && (
              <Link to={person}>
                <Icon height={15} width={15} fill="#999999" icon="share" />
              </Link>
            )}
          </TitleIcons>
        </TitleContainer>
        {description && (
          <Description className={editedClass} onClick={this.descriptionClick}>
            <div>
              <Icon icon="pencil" fill="#EB5757" height={12} width={12} />
            </div>
            <span dangerouslySetInnerHTML={{ __html: description }} />
          </Description>
        )}
        <AccordionContent open={open}>{<div>{children}</div>}</AccordionContent>
        <ButtonContainer>
          {isContentDisabled && (
            <ViewButton onClick={this.buttonClick}>
              {open ? "Свернуть" : "Развернуть"}
            </ViewButton>
          )}
        </ButtonContainer>
      </AccordionContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Accordion/index.js